import React from 'react';
import PublicLayout from './PublicLayout';

export default function HIPAAPage() {
  return (
    <PublicLayout title="HIPAA Notice" eyebrow="Legal" lastUpdated="February 18, 2026">
      <p className="lead">ScensobConnect provides a Business Associate Agreement (BAA) to covered-entity customers who use the platform to staff roles involving access to Protected Health Information (PHI).</p>
      <h2>What we do</h2>
      <ul>
        <li>Encrypt all data at rest (AES-256) and in transit (TLS 1.2+).</li>
        <li>Maintain audit logs of every administrative action involving worker, location, or shift records.</li>
        <li>Restrict access on a least-privilege, role-based basis.</li>
        <li>Sign HIPAA Business Associate Agreements with all sub-processors that may incidentally process PHI on our behalf.</li>
        <li>Train all employees on HIPAA basics on hire and annually.</li>
      </ul>
      <h2>What ScensobConnect is not</h2>
      <p>The platform does <strong>not</strong> store medical records, clinical notes, lab results, or any other patient PHI. It stores <em>workforce</em> information: who worked where, when, and at what rate. PHI never enters the platform.</p>
      <h2>Getting a BAA</h2>
      <p>If your organization requires a BAA before going live, email <a href="mailto:security@scensobconnect.com">security@scensobconnect.com</a>. Standard BAA turnaround is 2 business days.</p>
      <h2>Incident response</h2>
      <p>Suspected breach? Email <a href="mailto:security@scensobconnect.com">security@scensobconnect.com</a> immediately. We will acknowledge within 4 hours and notify affected covered entities within 24 hours per HIPAA timelines.</p>
    </PublicLayout>
  );
}
